import React from "react";
import "./RewardsHeader.css";
import headerImg from "../../../assets/rewards/header.webp";

const RewardsHeader = () => {
  return (
    <div className="gray-background-bg custom-black" id="rewards-header-bg">
      <div className="component-max-width">
        <div className="row reverse-column">
          <div className="col-lg-6 d-flex align-items-center">
            <div id="banner-intro-text">
              <h1 className="primary-light-text">
                EARNING <span className="colourful-text">REWARDS</span>{" "}
                <br className="line-breaking-none" /> HAS{" "}
                <span className="colourful-text">NEVER</span> BEEN{" "}
                <br className="line-breaking-none" />
                THIS EASY
              </h1>
              <p className="primary-light-text">
                BAAI is an AI Engine that rewards you for your digital
                engagements
              </p>
              <a href="#join"> <button id="join-header-btn" className="primary-light-bg">
                Register
              </button>
             </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-image">
              <img className="img-fluid" src={headerImg} width="612" height="580" alt="EARNING REWARDS" loading="lazy"  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardsHeader;
